<template>
  <div>Setting</div>
</template>

<script>
export default {
  name: 'SettingsPage'
};
</script>

<style>

</style>
